var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraftEmail = function SvgDraftEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".draft-email_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.7 22.3-4.2 1.2 1.2-4.2 7.179-7.179a2.121 2.121 0 0 1 3 3ZM18.979 13.021l3 3M12.7 19.3l3 3M13.5 14.5H2A1.5 1.5 0 0 1 .5 13V2A1.5 1.5 0 0 1 2 .5h18A1.5 1.5 0 0 1 21.5 2v6.5",
    className: "draft-email_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.067.946 11 9 .933.946",
    className: "draft-email_svg__a"
  })));
};
export default SvgDraftEmail;